import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SystemLens } from 'pages/systemLens/SystemLens'

import { systemLensSearchParams } from './-searchParams'

const RouteComponent = () => {
  const { siteId, systemId } = Route.useSearch()

  if (!siteId) {
    return <Outlet />
  }

  return <SystemLens siteId={siteId} systemId={systemId} />
}

export const Route = createFileRoute('/system-lens/')({
  component: RouteComponent,
  validateSearch: systemLensSearchParams,
  staticData: {
    title: 'System Lens',
  },
})
